var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 7", fill: "none" }, props),
    React.createElement("path", { d: "M12.36.232a1.001 1.001 0 0 1 1.281 1.537l-6 5c-.37.309-.91.309-1.281 0l-6-5A1.001 1.001 0 0 1 1.64.232l5.36 4.466L12.36.232z", fill: "#B7B7B7" })
  );
});